export const customerBankAccountState: { [key: string]: any } = {
    iban: '',
    bic: '',
    bankName: '',
    bankAccountOwner: '',
};
